module.exports = __webpack_public_path__ + "static/media/cao-hong-240gr-daedong.640728f3.jpg";